import { Component } from 'react';
import { registerConfirmationHandler } from '../../../routing/history';
import InterceptorModal from './InterceptorModal';

interface Callback {
    (allowNavigation: boolean): void;
}

interface State {
    message?: string;
    callback: Callback | null;
}

export default class GlobalInterceptorModal extends Component<{}, State> {
    unregister: null | (() => void) = null;

    state: State = {
        callback: null,
    };

    componentDidMount() {
        this.unregister = registerConfirmationHandler(this.getConfirmation);
    }

    componentWillUnmount() {
        this.unregister!();
        this.unregister = null;
    }

    render() {
        return (
            <InterceptorModal isOpen={!!this.state.callback} callbacks={this.callbacks} message={this.state.message} />
        );
    }

    callbacks = {
        onConfirm: () => {
            const callback = this.state.callback;
            if (!callback) throw new Error('OnConfirm called while not waiting for confirmation');
            this.setState({ callback: null, message: undefined }, () => {
                callback(true);
            });
        },
        onCancel: () => {
            const callback = this.state.callback;
            if (!callback) throw new Error('OnCancel called while not waiting for confirmation');
            this.setState({ callback: null, message: undefined }, () => {
                callback(false);
            });
        },
    };

    getConfirmation = (message: string, callback: Callback) => {
        this.setState({ callback, message });
    };
}
